import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import { isEqual } from "lodash";
import { Autocomplete, SearchBar } from "../../index";
import { isMultipleOperator } from "../utils";
import styles from "./filtersForm.module.scss";
const getFilterValue = (filter, multiple) => {
    if (multiple)
        return filter.values;
    if (filter.values.length === 1)
        return filter.values[0];
    return null;
};
const FilterOptionComponent = ({ filter, filterOption, onChange, }) => {
    var _a;
    const [autocompleteInputValue, setAutocompleteInputValue] = useState("");
    const isMultiple = filter.operation !== null && isMultipleOperator(filter.operation);
    switch (filterOption.component) {
        case "autocomplete":
            return (React.createElement(Autocomplete, { id: "value-autocomplete", multiple: isMultiple, value: getFilterValue(filter, isMultiple), getOptionLabel: (option) => {
                    var _a;
                    const label = (_a = filterOption.getOptionLabel) === null || _a === void 0 ? void 0 : _a.call(filterOption, option);
                    if (typeof label !== "object") {
                        return label !== null && label !== void 0 ? label : option;
                    }
                    else {
                        return label.label;
                    }
                }, isOptionEqualToValue: (option, value) => isEqual(option, value), filterSelectedOptions: true, loading: filterOption.isLoading, loadingText: "Loading...", options: (_a = filterOption.options) !== null && _a !== void 0 ? _a : [], freeSolo: filterOption.freeSolo, placeholder: filterOption.placeholder, classes: { listbox: "visible-overflow" }, onChange: (_event, value) => {
                    if (value) {
                        onChange(Array.isArray(value) ? value : [value]);
                    }
                    else {
                        onChange([]);
                    }
                }, inputValue: autocompleteInputValue, onInputChange: (_event, value, reason) => {
                    if (reason === "input" &&
                        filterOption.multiValueDelimiter &&
                        value.includes(filterOption.multiValueDelimiter)) {
                        const newValues = value
                            .split(filterOption.multiValueDelimiter)
                            .map((item) => item.trim())
                            .filter((item) => item !== "");
                        onChange(Array.from(new Set([...filter.values, ...newValues])));
                        setAutocompleteInputValue("");
                    }
                    else {
                        setAutocompleteInputValue(value);
                    }
                }, renderOption: (props, option) => {
                    var _a;
                    const label = (_a = filterOption.getOptionLabel) === null || _a === void 0 ? void 0 : _a.call(filterOption, option);
                    if (typeof label !== "object") {
                        return (React.createElement("li", { ...props, key: option }, label !== null && label !== void 0 ? label : option));
                    }
                    else {
                        return (React.createElement("li", { ...props, key: option },
                            React.createElement("div", null,
                                React.createElement("div", null, label.label),
                                React.createElement("div", { className: styles["value-secondary-text"] }, label.secondaryText))));
                    }
                } }));
        case "date":
            return (React.createElement(TextField, { id: "value-date-picker", type: "date", label: "", value: filter.values.length === 1 ? filter.values[0] : "", onChange: (event) => onChange(event.target.value ? [event.target.value] : []), fullWidth: true }));
        case "input":
            return (React.createElement(SearchBar, { id: "value-input", value: filter.values.length === 1 ? filter.values[0] : "", onChange: (value) => onChange(value ? [value] : []), label: "", placeholder: filterOption.placeholder, slotProps: {
                    htmlInput: { maxLength: 256, ...filterOption.inputProps },
                } }));
        default:
            return null;
    }
};
const ValueField = (props) => {
    return (React.createElement("div", { className: styles.value },
        React.createElement("div", { className: styles["field-label"] }, "Value"),
        React.createElement(FilterOptionComponent, { ...props })));
};
export default ValueField;
//# sourceMappingURL=ValueField.js.map